import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import UserDeleteModal from './UserDeleteModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  status: state.modal.userDeleteModal,
  table: state.user.table,
  user: state.user
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_USER_DELETE, false),
  deleteUsersByArray: actions.user.deleteUsersByArray,
  deleteUserById: actions.user.deleteUserById,
  updateTable: actions.user.updateTable,
  getDivisions: actions.division.getDivisions
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserDeleteModal)



// WEBPACK FOOTER //
// ./src/components/Modals/UserDeleteModal/index.js